/** @format */

//import components
import HeadTitle from "../../components/global/HeadTitle";
import NewServices from "../../components/pops/service/NewServices";
import NewSection from "../../components/pops/service/NewSection";
import ServicesContainer from "./Services-container";
import ChildNewServices from "../../components/pops/service/ChildNewServices";
//importing assets
import { useDispatch, useSelector } from "react-redux";
import {
  showChildService,
  showService,
  showSectionService,
} from "../../store/stateSlice";
import { useEffect } from "react";
import { getAll } from "../../store/helper";
import { Spinner1 } from "../../components/spinners/Spinner1";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";

const ServiceDomains = () => {
  const dispatch = useDispatch();
  const category = useSelector((state) => state.category);
  const render = useSelector((state) => state.toggleState.value.render);

  const addChildService = () => {
    dispatch(showChildService());
  };

  useEffect(() => {
    dispatch(getAll({ path: "/categories" }));
  }, [dispatch, render]);
  return (
    <NavbarAndSidebar>
      {category.loading && <Spinner1 />}

      <NewServices />
      <NewSection />
      <ChildNewServices />

      <div className="profile__head mb__small">
        <HeadTitle title="  اقسام الخدمات" />
        <div className="display-flex">
          <button
            className="btn btn__primary"
            onClick={() => dispatch(showSectionService({ id: null }))}
          >
            اضافة قسم جديد
          </button>
          <button
            className="btn btn__primary"
            onClick={() => dispatch(showService())}
          >
            اضافة مجموعة خدمات جديدة
          </button>
        </div>
      </div>
      <div className="mb__small" />
      <div className="services-domains">
        {category.allCategory &&
          category.allCategory?.map((item, key) => (
            <ServicesContainer
              item={item}
              addService={true}
              addChildService={addChildService}
            />
          ))}
      </div>
    </NavbarAndSidebar>
  );
};
export default ServiceDomains;
